import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import DesktopResponsive from './responsive/Features/DesktopResponsive';
import MobileResponsive from './responsive/Features/MobileResponsive';

class Features extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>EditPage Features | AI Generation, ReMix, and Click-to-Edit</title>
          <meta
            content="Explore EditPage features: AI homepage generation, WebBot guided choices, ReMix variations, inline editing, image and logo controls, and publishing workflows."
            name="description"
          />
          <meta
            property="og:title"
            content="EditPage Features | AI Generation, ReMix, and Click-to-Edit"
          />
          <meta
            property="og:description"
            content="Explore EditPage features: AI homepage generation, WebBot guided choices, ReMix variations, inline editing, image and logo controls, and publishing workflows."
          />
          <meta
            name="twitter:title"
            content="EditPage Features | AI Generation, ReMix, and Click-to-Edit"
          />
          <meta
            name="twitter:description"
            content="Explore EditPage features: AI homepage generation, WebBot guided choices, ReMix variations, inline editing, image and logo controls, and publishing workflows."
          />
          <meta content="EditPage" name="generator" />
          <link rel="canonical" href="https://www.editpage.com/features" />
        </Helmet>
        <DesktopResponsive history={this.props.history} />
        <MobileResponsive history={this.props.history} />
      </div>
    );
  }
}

export default Features;
